<script>
import {
  getAllocatedSeats,
  getNumberOfOrdersForTable,
  getSeatsUsedByOrder,
  getTablesForOrder,
  setTablesForOrder,
} from "@/common/assignments";
import AssignmentSelect from "@/common/components/AssignmentSelect.vue";

export default {
  name: "OrdersTable",
  components: {
    AssignmentSelect,
  },
  props: {
    orders: { type: Array, required: true },
    tableList: { type: Array, required: true },
  },
  emits: ["assigned", "edit"],
  computed: {
    orderTables() {
      const orderTables = {};
      this.orders.forEach((o) => (orderTables[o.number] = getTablesForOrder(o)));

      return orderTables;
    },
    tableIds() {
      return this.tableList.map((t) => {
        const ordersOnTable = getNumberOfOrdersForTable(this.orders, t.tableId);
        return {
          value: t.tableId,
          label: `${t.tableId} [${ordersOnTable}]`
        }
      });
    },
  },
  methods: {
    assignTables(order, tables) {
      setTablesForOrder(order, tables).forEach((t) =>
        this.$emit("assigned", order, t)
      );
    },
    getAllocatedSeats,
    getSeatsUsedByOrder,
  },
};
</script>

<template>
  <table>
    <tr>
      <th>Order</th>
      <th class="account-column">Account</th>
      <th>Seats</th>
      <th class="contact-column">Contact</th>
      <th>Tables</th>
    </tr>
    <tr v-for="order in orders" :key="order.number">
      <td>{{ order.number }}</td>
      <td>{{ order.account }}</td>
      <td
        :class="{ 'text-danger': getSeatsUsedByOrder(order) > order.seatCount }"
      >
        {{ getSeatsUsedByOrder(order) }} / {{ order.seatCount }}
      </td>
      <td>{{ order.contact }}</td>
      <td class="stored-items">
        <AssignmentSelect
          :model-value="orderTables[order.number]"
          :options="tableIds"
          placeholder="Begin typing to assign table"
          :seats-for="(tableNumber) => getAllocatedSeats(order, tableNumber)"
          @input="assignTables(order, $event)"
          @edit="$emit('edit', order, $event)"
        />
      </td>
    </tr>
  </table>
</template>
